export default "__VITE_ASSET__A9A2uXk$__"